
import React, { Component, PropTypes } from 'react';
import placeToLink from '../lib/placeToLink';
import classNames from 'classnames';
import axios from 'axios';


export default class PlaceModal extends React.Component {

  constructor() {
    super();

    this.state = {
      url:'',
      open:false,
      place:[],
      fetched: false
    }
  }

  componentWillReceiveProps(props) {
    this.setState({
      url:props.url,
      open:props.open
    });
  }

  componentDidMount() {
    const props = this.props;
    this.setState({
      url:props.url,
      open:props.open
    });
    axios.get('/json/place.json').then((item) => {
      const place = item.data.place;
      this.setState({
        place,
        fetched:true
      });
    });
  }

  closeModal() {
    if (this.props.onClose) {
      this.props.onClose();
      this.setState({
        open:false,
        url:'#'
      })
    }
  }

  placeToLink() {
    const url = this.state.url;
    if (!this.state.place) {
      return '';
    }
    const place = this.state.place.find((item) => url === item.exam_station_area);
    if(!place) {
      return '';
    }
    return `${place.url}/tpl/include/iframe-place-body.html`;
  }

  render() {
    const open = this.state.open;
    const url = this.placeToLink();
    return (  
        <div className={classNames("frame-modal-bg",{'active':open})}>
          <div className="frame-modal">
            {open && <iframe src={url} className="frame-modal-body"/>}
            <div className="frame-modal-footer">
              <button className="frame-modal-close-btn" onClick={this.closeModal.bind(this)}>閉じる</button>
            </div>
          </div>
        </div>);
  }
}